import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export enum UserInviteStatusEnum {
  CREATED = 'created',
  WORKING = 'working',
  ERROR = 'error',
  SENT = 'sent',
  EXPIRED = 'expired',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled'
}

export class IUser {
  id: string;
  creatorId: number;
  fullname: string;
  email: string;
  status: UserInviteStatusEnum;
  dateExpires: string;
  dateSent: string;
  dateAccepted?: string;
  createdAt: string;
  updatedAt: string;
  vendorAccess?: {
    accessLevel: string;
    vendorId: number;
  };
  companyAccess?: {
    accessLevel: string;
    companyId: number;
    vendorId: number;
  };
}

export class IUserInviteResponse {
  @Type(() => IUser)
  result: IUser;
  inviteUrl: string;
  details: {
    inviterName: string;
    vendorName: string;
    companyName: string;
  };
}

export class IUserInviteListResponse extends IPagination {
  @Type(() => IUser)
  results: IUser[];
}

export class IUserInviteQueryDto extends IQueryPaginationDto {
  creatorId?: number;
  email?: string;
}
